(function (window) {
  'use strict';

  const desktopMenuTriggers = document.querySelectorAll('.desktop-navigation__link')
  const desktopNavigation = document.querySelector('.desktop-navigation')

  desktopMenuTriggers.forEach(link => {
    link.addEventListener('click', event => handleMegaMenuEvent(event))
  })

  function handleMegaMenuEvent(event) {
    event.preventDefault()
    if (event.target.nodeName !== "A") {
      return;
    }
    const menuId = event.target.getAttribute('aria-controls')
    if (menuId === desktopNavigation.openedMegaMenuId) {
      closeMegaMenu(menuId)
    } else if (typeof desktopNavigation.openedMegaMenuId === 'undefined') {
      openMegaMenu(menuId)
    } else if (menuId !== desktopNavigation.openedMegaMenuId) {
      closeMegaMenu(desktopNavigation.openedMegaMenuId)
      openMegaMenu(menuId)
    }

    function openMegaMenu(menuId = '') {
      const link = document.querySelector(`[aria-controls='${menuId}'`)
      const megaMenu = document.querySelector(`[id='${menuId}']`)
      megaMenu.setAttribute('aria-hidden', 'false')
      link.setAttribute('aria-expanded', 'true')
      link.parentElement.classList.add('is-active')
      desktopNavigation.openedMegaMenuId = menuId
      // Focus on the first element of the opened menu.
      const linksOnMegaMenu = megaMenu.querySelectorAll('a')
      const first = linksOnMegaMenu[0]
      const last = linksOnMegaMenu[linksOnMegaMenu.length - 1]
      first.focus()
      megaMenu.addEventListener('keyup', keyboardCloseEvent)
      // If a flyout is open, close it.
      if (window.componentEvents) {
        componentEvents.emitEvent('close-all-flyouts');
      }
    }

    function keyboardCloseEvent(event) {
      if(event.which === 27) {
        closeMegaMenu(menuId)
      }
    }

    function closeMegaMenu(menuId = '') {
      const openedMenu = document.querySelector(`#${menuId}`)
      const openerLink = document.querySelector(`[aria-controls='${menuId}']`)
      openedMenu.removeEventListener('keyup', keyboardCloseEvent)
      openedMenu.setAttribute('aria-hidden', 'true')
      openerLink.setAttribute('aria-expanded', 'false')
      openerLink.parentElement.classList.remove('is-active')
      openerLink.focus()
      delete desktopNavigation.openedMegaMenuId
    }

    function resetDesktopMenu() {
      if (typeof desktopNavigation.openedMegaMenuId !== 'undefined') {
        closeMegaMenu(desktopNavigation.openedMegaMenuId)
      }
    }

    if (window.componentEvents) {
      componentEvents.on('close-navigation', resetDesktopMenu);
    }

    window.addEventListener('resize', debounce(resetDesktopMenu, 250))

  }

})(this);
